/**
 * @file routes/_app/settings/crops.tsx
 * @description 「業務字典 — 作物管理」維護頁路由。
 */
import { createFileRoute } from '@tanstack/react-router';
import { CropsPage } from '@/components/settings/CropsPage';

export const Route = createFileRoute('/_app/settings/crops')({
  component: CropsPage,
});
